import React, { useCallback, useState } from "react";
import useHotkey from "hooks/useHotkey";
import { NavItem } from "components/bootstrap";
import NavIcon from "components/navigation/NavIcon";
import QuickJumpModal from "./QuickJumpModal";
const QuickJumpModalContainer = () => {
  const [showQuickJumpModal, setShowQuickJumpModal] = useState(false);
  const toggleModal = useCallback(() => setShowQuickJumpModal((cur) => !cur), [setShowQuickJumpModal]);
  useHotkey({
    actionKey: "show-quick-jump-modal",
    callback: () => setShowQuickJumpModal(true),
    scope: "general"
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NavItem, { id: "quickjump-search-nav", onClick: toggleModal }, /* @__PURE__ */ React.createElement(NavIcon, { type: "search", title: "Search" })), showQuickJumpModal && /* @__PURE__ */ React.createElement(QuickJumpModal, { onToggle: () => toggleModal() }));
};
export default QuickJumpModalContainer;
